import { DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import styled from 'foundations-theming/utils';
import { createRef, PureComponent } from 'react';
import { uniqueId } from 'UIComponents/utils/underscore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContainer = styled.div.withConfig({
  displayName: "UITextToolbarInputDropdown__StyledContainer",
  componentId: "sc-1lm3bup-0"
})(({
  $use,
  $disabled,
  theme
}) => ({
  '&&&': {
    backgroundColor: $disabled ? theme.color['fill-tertiary-disabled'] : $use === 'on-dark' ? theme.color['fill-surface-default'] : theme.color['fill-field-disabled'],
    borderColor: $disabled ? theme.color['fill-tertiary-disabled'] : theme.color['border-core-default'],
    borderRadius: theme.borderRadius['100'],
    borderStyle: 'solid',
    borderWidth: theme.borderWidth['100'],
    color: $disabled ? theme.color['text-tertiary-disabled'] : theme.color['text-core-default'],
    cursor: $disabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    fontSize: theme.typography['detail-100'].fontSize,
    blockSize: '32px',
    inlineSize: '62px',
    padding: theme.space['100'],
    transition: 'all 150ms ease-out',
    ':hover': {
      backgroundColor: $disabled ? '' : theme.color['fill-transparent-hover']
    },
    input: {
      color: `${$disabled ? theme.color['text-core-disabled'] : theme.color['text-core-subtle']} !important`,
      fontSize: theme.typography['detail-100'].fontSize
    }
  }
}));
const StyledItemWrapper = styled.div.withConfig({
  displayName: "UITextToolbarInputDropdown__StyledItemWrapper",
  componentId: "sc-1lm3bup-1"
})(({
  theme
}) => ({
  transition: 'background-color 150ms ease',
  color: theme.color['icon-core-default'],
  inlineSize: '100%',
  paddingBlock: theme.space[200],
  paddingInline: theme.space[300],
  textAlign: 'left',
  fontSize: theme.typography['detail-100'].fontSize,
  fontWeight: theme.typography['detail-100'].fontWeight,
  lineHeight: theme.typography['detail-100'].lineHeight
}));
export const TextToolbarSelectOption = ({
  option
}) => /*#__PURE__*/_jsx(StyledItemWrapper, {
  children: option.text
});
class UITextToolbarInputDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.handleFocus = () => {
      var _this$inputRef$curren;
      this.setState({
        open: true
      });
      (_this$inputRef$curren = this.inputRef.current) === null || _this$inputRef$curren === void 0 || _this$inputRef$curren.focus();
    };
    this.handleBlur = () => {
      this.setState({
        open: false,
        inputValue: null
      });
    };
    this.handleKeyDown = event => {
      if (event.key === 'Enter' && this.state.inputValue) {
        this.props.onInputSelect(this.state.inputValue);
        event.preventDefault();
      } else if (event.key === 'Escape') {
        var _this$inputRef$curren2;
        (_this$inputRef$curren2 = this.inputRef.current) === null || _this$inputRef$curren2 === void 0 || _this$inputRef$curren2.blur();
      }
    };
    this.handleOptionSelect = event => {
      const target = event.target;
      this.props.onOptionSelect(target.value);
    };
    this.handleButtonClick = event => {
      const target = event.target;
      if (this.props.disabled || target.nodeName === 'INPUT') {
        return;
      }
      if (this.state.open) {
        this.handleBlur();
      } else {
        this.handleFocus();
      }
    };
    this.handleOpenChange = event => {
      const target = event.target;
      if (target.value) {
        this.handleFocus();
      } else {
        this.handleBlur();
      }
    };
    this.handleInputValueChange = event => {
      this.setState({
        inputValue: event.target.value
      });
    };
    this.renderInputComponent = inputProps => {
      return /*#__PURE__*/_jsxs(StyledContainer, {
        $disabled: !!inputProps.disabled,
        $use: this.props.use || 'default',
        onClick: this.handleButtonClick,
        children: [/*#__PURE__*/_jsx(TextInput, Object.assign({
          marginInline: "50",
          marginBlock: "25",
          blockSize: "20px",
          inlineSize: "40px",
          padding: "0",
          cursor: inputProps.disabled ? 'not-allowed' : 'text'
        }, inputProps, {
          styled: false
        })), /*#__PURE__*/_jsx(DropdownCaret, {
          buttonUse: "transparent",
          marginInlineEnd: "100"
        })]
      });
    };
    this.state = {
      open: false,
      inputValue: null
    };
    this._id = uniqueId('text-toolbar-input-');
    this.inputRef = /*#__PURE__*/createRef();
  }
  render() {
    const {
      disabled,
      options,
      placeholder,
      value
    } = this.props;
    const {
      open,
      inputValue: _inputValue
    } = this.state;
    let inputValue = value || '';
    if (open && typeof _inputValue === 'string') {
      inputValue = _inputValue;
    }
    inputValue = inputValue.toString();
    return /*#__PURE__*/_jsx(Select, {
      anchorType: "input",
      autoFocus: open,
      closeOnTargetLeave: true,
      disabled: disabled,
      filterOptions: false,
      id: this._id,
      inputComponent: this.renderInputComponent,
      inputRef: this.inputRef,
      inputValue: inputValue,
      value: inputValue,
      minimumSearchCount: Infinity,
      onChange: this.handleOptionSelect,
      onInputKeyDown: this.handleKeyDown,
      onInputValueChange: this.handleInputValueChange,
      onOpenChange: this.handleOpenChange,
      optionComponent: TextToolbarSelectOption,
      open: open,
      options: options,
      placeholder: placeholder
    });
  }
}
UITextToolbarInputDropdown.displayName = 'TextToolbarInputDropdown';
export default UITextToolbarInputDropdown;